import React from "react";
import PropTypes from "prop-types";
import { controlPropTypes } from "../../formhelpers";
import TypeaheadCore, { MISSING } from "./Core";

export const STATUS_MESSAGE = {
    EMPTY: "Nothing Found",
    PARTIAL: "Type what you're looking for; more choices available.",
    LOADING: "Refreshing options...",
    ERROR: "Error loading results; try again?"
};

export default class Typeahead extends React.Component {
    constructor(props) {
        super(props);
        const {debounceTime} = props;
        this.onSearch = _.debounce(this.onSearch.bind(this), debounceTime);
    }

    isServer(props) {
        props = props || this.props;
        const descriptor = props.descriptor || {};
        const config = descriptor.config || {};
        return props.mode === "server" && (config.otherEntityKey != null);
    }

    onSearch(searchText, sort) {
        const {onSearch, descriptor} = this.props;
        onSearch && onSearch(descriptor, searchText, sort);
    }

    buildOptions() {
        const {options, valueKey, labelKey, addMissing, multiValued } = this.props;
        const optionsArr = [...options];
        if((addMissing) && !multiValued) {
            optionsArr.unshift({
                [valueKey]: MISSING.VALUE,
                [labelKey]: MISSING.LABEL
            });
            return optionsArr;
        }
        return optionsArr;
    }

    buildColumns() {
        const {labelKey, columns} = this.props;
        if(columns.length) {
            return columns;
        }
        // create a default column
        return [{
            key: labelKey,
            isSortable: false,
            includeInFilter: true,
            label: null
        }];
    }

    buildStatusMessage() {
        const {statusMessage, isLoading, isPartial, isError} = this.props;
        let status = statusMessage;
        if(this.isServer() && !status) {
            if(isPartial) {
                status = STATUS_MESSAGE.PARTIAL;
            }
            if(isLoading) {
                status = STATUS_MESSAGE.LOADING;
            }
            if(isError) {
                status = STATUS_MESSAGE.ERROR;
            }
        }
        return status;
    }

    render() {
        return (
            <TypeaheadCore
                {...this.props}
                onSearch={this.onSearch}
                options={this.buildOptions()}
                columns={this.buildColumns()}
                statusMessage={this.buildStatusMessage()}
                isServer={this.isServer()}
            />
        );

    }
}

Typeahead.defaultProps = {
    debounceTime: 200,
    searchPageSize: 100,
    dropdownLength: 8,
    mode: "client",
    options: [],
    columns: [],
    multiValued: false,
    valueKey: "value",
    labelKey: "label",
    showRecordBrowserIcon: false,
    showSelectAll: false,
    autoSelectFirstItem: false,
    autoSelectOnlyOption: false,
    addMissing: false,
    keepSelectionInList: false,
};

Typeahead.propTypes = {
    ...controlPropTypes(),
    onSearch: PropTypes.func,
    onRecordbrowserClick: PropTypes.func,

    // Value is assumed to be the inflated value(s) or null. Meaning an object
    // with {[valueKey]: ... , [labelKey]: ... } or array with those objects.
    // This is different from how the jQuery control worked which only supplied
    // the value string(s) and expected the inflated value to exist in the
    // options list.
    value:  PropTypes.oneOfType([PropTypes.object,PropTypes.arrayOf(PropTypes.object)]),

    options: PropTypes.arrayOf(PropTypes.object),
    columns: PropTypes.arrayOf(PropTypes.shape({
        includeInFilter: PropTypes.bool,
        isSortable: PropTypes.bool,
        key: PropTypes.string.isRequired,
        label: PropTypes.string,
    })).isRequired,

    mode: PropTypes.oneOf(["client","server"]),
    valueKey: PropTypes.string.isRequired,
    labelKey: PropTypes.string.isRequired,
    addMissing: PropTypes.bool,
    multiValued: PropTypes.bool,
    statusMessage: PropTypes.string,
    autoSelectOnlyOption: PropTypes.bool,
    autoSelectFirstItem: PropTypes.bool,
    keepSelectionInList: PropTypes.bool,
    showRecordBrowserIcon: PropTypes.bool,
    showSelectAll: PropTypes.bool,

    dropdownLength: PropTypes.number,
    debounceTime: PropTypes.number,
    searchPageSize: PropTypes.number,

    // these are required for server lists
    isLoading: PropTypes.bool,
    isPartial: PropTypes.bool,
    isError: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./app/lib/common/descriptorcontrols/BaseControls/Typeahead/Typeahead.js